import { FunctionComponent, useContext, useEffect, useState } from "react";
import NotificationTopSection from "./NotificationTopSection";
import RecentNotification from "./recent-notification/RecentNotification";
import PastNotification from "./past-notification/PastNotification";
import styles from "./NotificationComponent.module.css";
import { useLazyQuery } from "@apollo/client";
import { GET_NOTIFICATIONS } from "./api/NotificationQuery";
import { getFormattedDate, notificationData} from '../../../helper'
import { CircularProgress } from "@mui/material";
import { globalContext } from "../../../Provider/AppProvider";

interface NotificationProps{
  closePopup: () => void
}
const NotificationComponent: FunctionComponent<NotificationProps> = ({closePopup}) => {
  const [showNotifications,setShowNotifications] = useState<boolean>(false);
  const [recentNotifications,setRecentNotifications] = useState<[notificationData]>();
  const [pastNotifications,setPastNotifications] = useState<[notificationData]>();
  const [recentNotificationsCount,setRecentNotificationsCount] = useState<number>(0);
  const [pastNotificationsCount,setPastNotificationsCount] = useState<number>(0);
  const [clearNotifications,setClearNotifications] = useState<boolean>(false);
  const {globalState,handleGlobalState} = useContext<any>(globalContext)



  

  const [getWebNotification] = useLazyQuery(GET_NOTIFICATIONS,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      setRecentNotifications(data?.current);
      setPastNotifications(data?.past);
      setRecentNotificationsCount(data?.currentCount?.aggregate?.count);
      setPastNotificationsCount(data?.pastCount?.aggregate?.count);
      setShowNotifications(true);
    }
  })

  useEffect(()=>{
    const tempValue = {...globalState}
    if(globalState.error.errorClicked){
      tempValue.error.errorClicked = false;
      tempValue.globalSearch.searchtext = "";
      tempValue.error.text = "";
      tempValue.error.approximateTpArray = null
      tempValue.error.ticketPlacementId = null
      tempValue.error.status = ""
      handleGlobalState(tempValue)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  
  useEffect(()=>{
    const date = getFormattedDate(new Date());
    getWebNotification({
      variables:{
        todayDate: date,
        userId: globalState?.profile?.id
      }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[clearNotifications])
  return (
    <div className={styles.notification}>
      { showNotifications && <NotificationTopSection setClearNotifications={setClearNotifications} NotificationCount={showNotifications ? (recentNotificationsCount + pastNotificationsCount) : 0 }/>}
      <div className={showNotifications?styles.notificationOuter:styles.notificationCards}>
      {showNotifications  && (
        <>
          {recentNotificationsCount !== 0   && <RecentNotification handleClose={closePopup} notificationData={recentNotifications}/>}
          {pastNotificationsCount !== 0  && <PastNotification handleClose={closePopup} notificationData={pastNotifications}/>}
        </>
        ) 
        }
      {!showNotifications && <div className={styles.loader}><CircularProgress color="inherit" /></div>} 
        
      {recentNotificationsCount === 0 && pastNotificationsCount === 0 && showNotifications && <p className={styles.noDataFound}>No Data Found</p>}
      </div>

    </div>
  );
};

export default NotificationComponent;
